import { AssetStoreProvider } from '@app/providers/asset-provider'
import { FlexBox, Spinner } from '@vp/swan'
import { useIdentity } from '@vp/ubik-context'
import { useTranslation } from 'react-i18next'
import { FormDataProvider } from '../context/form-data-context'
import { PageFlowProvider } from '../context/page-flow-context'
import { usePageContentState } from '../hooks/use-page-content-state'
import { PageContent } from './layout/page-content'
import { PageLayout } from './layout/page-layout'
import type { Props } from './page'

export const ContactPageContent = ({ channel: requestedChannel }: Props) => {
  const { t } = useTranslation()
  const { auth } = useIdentity()

  const { channel, isPageLoading, shouldHidePage } = usePageContentState(requestedChannel)

  if (isPageLoading) {
    return (
      <FlexBox justifyContent="center" alignItems="center" style={{ minHeight: '300px' }}>
        <Spinner accessibleText={t('contact_us.page.steps.details.loading')} />
      </FlexBox>
    )
  }

  if (shouldHidePage || !channel) {
    return null
  }

  return (
    <AssetStoreProvider auth={auth}>
      <FormDataProvider channel={channel}>
        <PageFlowProvider channel={channel}>
          <PageLayout>
            <PageContent />
          </PageLayout>
        </PageFlowProvider>
      </FormDataProvider>
    </AssetStoreProvider>
  )
}
